/**
 * 批量导入用户成员关系 - 中文翻译
 */
export const batchImportUserMembershipsZh = {
  // 对话框
  title: '批量导入成员关系',
  dialogTitle: '批量导入成员关系',
  
  // 步骤
  steps: {
    title: '导入步骤',
    step1: '下载成员关系导入模板',
    step2: '按照模板格式填写用户-部门关系信息',
    step3: '上传填写好的文件',
    step4: '确认无误后提交导入',
  },
  
  // 模板相关
  template: {
    title: '模板说明',
    downloadBtn: '下载模板',
    downloading: '下载中...',
    downloaded: '模板已下载',
    fields: {
      email: '用户邮箱',
      emailDesc: '必填，用于查找已存在的用户',
      departmentCode: '部门编码',
      departmentCodeDesc: '必填，用户所属部门的编码',
      positionId: '岗位ID',
      positionIdDesc: '可选，用户的岗位ID（UUID格式）',
      managerEmail: '直属主管邮箱',
      managerEmailDesc: '可选，直属主管的邮箱地址',
      title: '部门内头衔',
      titleDesc: '可选，用户在该部门的职务名称',
      isPrimary: '是否主部门',
      isPrimaryDesc: '可选，填 true 或 false，默认 false',
    },
    autoCodeTip: '💡 提示：用户必须已存在系统中（通过Entra ID同步创建），此功能仅导入用户-部门关系',
  },

  // 上传相关
  upload: {
    title: '上传文件',
    required: '上传文件 *',
    placeholder: '点击选择文件或拖拽文件到此处',
    reselect: '点击重新选择文件',
    formatHint: '支持 .xlsx、.xls 格式',
    parsing: '解析中...',
    parseSuccess: '文件解析成功，共 {count} 条有效数据',
    parseWarning: '文件解析完成，发现 {count} 条无效数据',
    parseFailed: '文件解析失败，请检查文件格式',
  },

  // 表格
  table: {
    email: '用户邮箱',
    departmentCode: '部门编码',
    managerEmail: '主管邮箱',
    title: '头衔',
    isPrimary: '主部门',
    error: '错误信息',
    yes: '是',
    no: '否',
    empty: '-',
  },

  // 数据验证
  validation: {
    validData: '有效数据',
    invalidData: '无效数据',
    dataCount: '{count} 条',
    errorReasons: {
      missingRequired: '缺少必填字段（邮箱或部门编码）',
      invalidEmailFormat: '邮箱格式无效',
      invalidDepartmentCode: '部门编码格式无效',
    },
  },

  // 操作按钮
  actions: {
    cancel: '取消',
    confirm: '开始导入',
    confirmWithCount: '开始导入 ({count} 条)',
    importing: '导入中...',
  },

  // 消息提示
  messages: {
    noValidData: '没有有效数据可导入',
    importSuccess: '成功导入 {count} 条成员关系',
    importFailed: '导入失败，请稍后重试',
    importPartial: '导入完成：成功 {success} 条，失败 {failed} 条',
    userNotFound: '用户不存在: {email}',
    departmentNotFound: '部门不存在: {code}',
    managerNotFound: '主管不存在: {email}',
  },
};


